import { DeliveryMode } from '@msdyn365-commerce-modules/retail-actions';
import { IActionContext } from '@msdyn365-commerce/core';
import { getEstimatedAvailabilityAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { useCallback, useEffect, useState } from 'react';

const SALES_UNIT_OF_MEASURE = 2;

export const useVariantsAvailability = (actionContext: IActionContext, variantRecordIds: number[], location: string) => {
    const [isLoading, setIsLoading] = useState(true);
    const [availability, setAvailability] = useState<Map<number, number>>();

    const getAvailability = useCallback(async () => {
        if (!variantRecordIds.length) {
            setAvailability(undefined);
            setIsLoading(true);
            return;
        }

        setIsLoading(true);

        try {
            const availabilityResponse = await getEstimatedAvailabilityAsync(
                { callerContext: actionContext },
                {
                    ProductIds: variantRecordIds,
                    DeliveryModeTypeFilterValue: DeliveryMode.shipping,
                    QuantityUnitTypeValue: SALES_UNIT_OF_MEASURE,
                    FilterByChannelFulfillmentGroup: true
                }
            );
            const availabilityMap = new Map(
                availabilityResponse.AggregatedProductInventoryAvailabilities?.filter(
                    (item): item is { ProductId: number; MaximumPurchasableTotalAvailableQuantity: number } =>
                        item.MaximumPurchasableTotalAvailableQuantity !== undefined && item.ProductId !== undefined
                ).map(item => [item.ProductId, item.MaximumPurchasableTotalAvailableQuantity])
            );

            setAvailability(availabilityMap);
        } catch (error) {
            const message = `[${location}] Error fetching variants availability: ${error instanceof Error ? error.message : String(error)}`;
            actionContext.telemetry.error(message);
            console.error(message);
        }

        setIsLoading(false);
    }, [actionContext, variantRecordIds, location]);

    useEffect(() => {
        getAvailability();
    }, [getAvailability]);

    return { isLoading, availability };
};
